/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2024, Zumper
 */

import type { Property } from '@zcode/state-type'
import type { MaybeEmpty } from '@zcode/utility-types'
import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectTourIntegrationByGroupId } from '../../../../modules/multifamilyTourTimePicker/selectors'
import { fetchTourIntegration } from '../../../../modules/multifamilyTourTimePicker/thunks/fetchTourAvailability'

export const useGetTourIntegration = (
  entity:
    | MaybeEmpty<Pick<Property, 'groupId' | 'isTourDisabled' | 'mightHaveInstantTourScheduling'>>
    | null
    | undefined,
  skip?: boolean
) => {
  const dispatch = useDispatch()
  const tourIntegration = useSelector((state) =>
    entity?.groupId ? selectTourIntegrationByGroupId(state, entity.groupId) : undefined
  )
  useEffect(() => {
    if (entity?.groupId && !skip) {
      dispatch(fetchTourIntegration(entity))
    }
  }, [dispatch, entity, skip])
  return useMemo(() => {
    const fetching =
      entity?.groupId != null && (tourIntegration?.fetching || !tourIntegration?.fetchedAt)
    if (entity?.groupId && tourIntegration?.fetchedAt) {
      return { data: tourIntegration.integration, fetching, fetched: true }
    }
    return { data: null, fetching, fetched: false }
  }, [entity, tourIntegration])
}
